import React from 'react'
import { render } from 'react-dom'
import { RxDBValidatePlugin } from 'rxdb/plugins/validate'
import pouchAdapterIndexedDB from 'pouchdb-adapter-idb'
import { LOGGER } from '@cicero/data/utils'
import { DefaultTheme, ThemeProvider } from '@cicero/ui'

import * as serviceWorker from './serviceWorker'
import './index.css'
import { App } from './App'
import { Store, StoreContext } from './models/services'
import { FETCH_MODEL_OVER_HTTP, HANDSHAKE, QUERY_MODELS_OVER_HTTP, SYNC_MODELS_OVER_HTTP } from './actions'

if (!process.env.REACT_APP_API_ENDPOINT) { throw new Error('API_ENDPOINT not set') }
const store = (window as any)['store'] = new Store({
  name: 'entities',
  debug: false,
  defaultMaxWait: 3000,
  rxdbPlugins: [pouchAdapterIndexedDB, RxDBValidatePlugin],
  rxdbAdapter: 'idb',
  endpoint: process.env.REACT_APP_API_ENDPOINT,
  actions: [
    HANDSHAKE,
    SYNC_MODELS_OVER_HTTP,
    QUERY_MODELS_OVER_HTTP,
    FETCH_MODEL_OVER_HTTP,
  ],
})

store.dispatch({ type: HANDSHAKE })
store.schedule(SYNC_MODELS_OVER_HTTP, 10 * 1000)

LOGGER.setLevel('DEBUG')
LOGGER.info(store)

render(
  <React.StrictMode>
    <ThemeProvider theme={DefaultTheme}>
      <StoreContext.Provider value={store}>
        <App />
      </StoreContext.Provider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
